/** Shared outline icons for compact More menu rows. */
export function MoreMenuIcon({ name }: { name: string }) {
  const key = name.toLowerCase();
  const path = /profile|customer|team|rider|driver/.test(key)
    ? "M20 21v-2a7 7 0 0 0-14 0v2M12 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
    : /sound|alert|notification/.test(key)
      ? "M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4"
      : /sign.out/.test(key)
        ? "M9 3H4v18h5M9 12h12m-4-4 4 4-4 4"
        : /backup|download/.test(key)
          ? "M12 3v12m-4-4 4 4 4-4M4 16v5h16v-5"
          : /subscription|finance|payment/.test(key)
            ? "M3 5h18v14H3zM3 9h18M7 15h3"
            : /event|hours/.test(key)
              ? "M4 5h16v16H4zM8 2v6m8-6v6M4 11h16"
              : /legal|safety|privacy/.test(key)
                ? "M12 3 3 7v5c0 5 9 9 9 9s9-4 9-9V7zM8 12l3 3 5-6"
                : /support|help|review/.test(key)
                  ? "M4 13v-1a8 8 0 0 1 16 0v1M4 12H2v7h4v-7zm16 0h2v7h-4v-7M20 19v3h-6"
                  : /setting|categor|tag/.test(key)
                    ? "M4 6h16M4 12h16M4 18h16M8 3v6m8 0v6M10 15v6"
                    : "M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z";
  return (
    <span className="more-menu-row__icon" aria-hidden="true">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d={path} />
      </svg>
    </span>
  );
}
